import type { ContainerChild } from 'pixi.js';
import { Sprite } from 'pixi.js';
import type { ParticleInitConfig } from '../../../../libs/particles/updateParticle';
import { turnIntoParticle } from '../../../../libs/particles/updateParticle';

export async function shatterAnimation(pieces: ContainerChild[]): Promise<void> {
  const commonConfig: Omit<ParticleInitConfig, 'angularVelocity'> = {
    velocity: {
      distance: [0.1, 0.18],
      angle: [Math.PI * 0.5, Math.PI * -0.5],
      drag: 0.95,
    },
    gravity: 0.0005,
    angularDrag: 1,
  };

  await Promise.all(
    pieces.map((shard) => {
      if (shard.destroyed || !(shard instanceof Sprite)) return Promise.resolve();

      turnIntoParticle(shard, {
        ...commonConfig,
        velocity: {
          ...commonConfig.velocity,
          angle: Math.atan2(shard.y, shard.x),
        },
        angularVelocity: shard.x * 0.001,
      });

      return shard
        .tweenTo(
          {
            alpha: 0,
          },
          250,
          'sinIn',
          true,
        )
        .asyncOnComplete();
    }),
  );
}
